import { Box } from "@mittwald/flow-components/dist/components/Box";
import { H1 } from "@mittwald/flow-components/dist/components/H1";
import { Image } from "@mittwald/flow-components/dist/components/Image";
import { Text } from "@mittwald/flow-components/dist/components/Text";
import { TextLink } from "@mittwald/flow-components/dist/components/TextLink";
import TranslationProvider from "@mittwald/flow-components/dist/components/TranslationProvider/TranslationProvider";
import React from "react";
import { ContentBox } from "../../../../components/styled";
import successImage from "./img/relocation.svg";

interface ResultBoxProps {
  system: "kc" | "mstudio" | string;
  email: string;
}

export const ResultBox: React.FC<ResultBoxProps> = ({ system, email }) => {
  const textLink =
    system === "mstudio" ? (
      <TextLink action="https://studio.mittwald.de/login" i18n="mStudioLink" />
    ) : system === "kc" ? (
      <TextLink
        action="https://login.mittwald.de/index.php"
        i18n="kundencenterLink"
      />
    ) : null;

  return (
    <TranslationProvider name="resultBox" type="component">
      <ContentBox>
        <Box _alignItems="center" _flexDirection="column">
          <Box
            _alignItems="center"
            _flexDirection="column"
            _itemGap="m"
            _maxW={430}
          >
            <Image _height="auto" _width={230} url={successImage} />
            <H1 center i18n="orderCompleteHeadline" />
            <Text
              center
              i18n={{
                id: "orderCompleteText",
                values: {
                  email: email,
                },
              }}
            />
            {textLink}
          </Box>
        </Box>
      </ContentBox>
    </TranslationProvider>
  );
};
